module.exports = __webpack_public_path__ + "static/images/1_sunny_bike_night.128295dd.jpg";